import { useEffect } from 'react';
import API from '../api/axios';

export function useLocationTracker() {
    useEffect(() => {
        if (localStorage.getItem('locationEnabled') === 'false') return;
        if (!navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                try {
                    await API.put('/api/profile/location', {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                } catch (err) {
                    console.error('Location update failed:', err);
                }
            },
            (err) => {
                console.warn('Geolocation denied or unavailable:', err.message);
            },
            { timeout: 10000 }
        );
    }, []);
}